import styles from "./SmallFeatures.module.scss";
import RedCircleTickIcon from "@Icons/RedCircleTickIcon";
import HeadPhoneIcon from "@Icons/HeadPhoneIcon";
import MoneyBillIcon from "@Icons/MoneyBillIcon";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";
//

const SmallFeatures = ({ dataTestId }: { dataTestId?: string }) => {
  const { t } = useTranslationHook();
  const data = [
    {
      title: t("home.smallfeatures.verifiedpropertiestitle"),
      icon: <RedCircleTickIcon fill="#fff" height={20} width={20} />,
    },
    {
      title: t("home.smallfeatures.assistance24x7title"),
      icon: <HeadPhoneIcon fill="#fff" height={20} width={20} />,
    },
    {
      title: t("home.smallfeatures.lowestpriceguaranteetitle"),
      icon: <MoneyBillIcon fill="#fff" height={20} width={20} />,
    },
  ];
  return (
    <>
      <div className={styles.smallFeaturesContainer}>
        {data.map((feature: any, index: number) => (
          <div
            className={styles.smallFeature}
            data-testid={dataTestId}
            key={`small-feature-desktop-${index}`}
          >
            <span className={styles.icon}>{feature.icon}</span>
            <span data-testid={feature.title}>{feature.title}</span>
          </div>
        ))}
      </div>
    </>
  );
};

export default wrapperHOC(SmallFeatures, {
  componentName: "SmallFeatures-HeroSectionDesktop-Home",
  showForChina: true,
});
